import * as componentTypes from "../../constants/componentTypes";

import PricingTable from "./PricingTable";

/**
 * @class BaseInProductPackagePricingTable
 */
export default class BaseInProductPackagePricingTable extends PricingTable {
    /**
     * @param {String}  priceDefinition
     * @param {Boolean} localPrices
     * @param {Boolean} margins
     * @param {Boolean} markups
     * @param {Boolean} discounts
     * @param {Array}   marginList
     */
    constructor(priceDefinition, localPrices, margins, markups, discounts, marginList) {
        super(priceDefinition, localPrices, false, margins, markups, discounts, marginList);

        this.initTableColumns(marginList);
    }

    initTableColumns = (marginList) => {
        if (this._purchasePrice) {
            if (this._localPrices) {
                this._columns.push(componentTypes.COL_DEFAULT_PURCHASE_PRICE);
            }

            this._columns.push(componentTypes.COL_PURCHASE_PRICE);
            this._editableColumns.push(componentTypes.COL_PURCHASE_PRICE);
        }

        if (this._sellPrice) {
            if (this._localPrices) {
                this._columns.push(componentTypes.COL_DEFAULT_SELL_PRICE);
            }

            this._columns.push(componentTypes.COL_SELL_PRICE);
            this._editableColumns.push(componentTypes.COL_SELL_PRICE);
        }

        if (this._localPrices) {
            this._columns.push(componentTypes.COL_DEFAULT_VAT);
        }

        this._columns.push(componentTypes.COL_VAT);
        this._editableColumns.push(componentTypes.COL_VAT);

        if (this._localPrices) {
            this._columns.push(componentTypes.COL_DEFAULT_SURCHARGE);
        }

        this._columns.push(componentTypes.COL_SURCHARGE);
        this._editableColumns.push(componentTypes.COL_SURCHARGE);

        this._columns.push(componentTypes.COL_POS_COEFICIENT);
        this._editableColumns.push(componentTypes.COL_POS_COEFICIENT);

        let editableMargin = false;

        for (let margin of marginList) {
            if (this.isMarginColumnVisible(margin)) {
                this._marginColumns.push(margin);

                if (margin.local) {
                    editableMargin = true;
                }
            }
        }

        if (editableMargin) {
            this._editableColumns.push(componentTypes.COL_MARGIN);
        }
    };
}
